/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as publicRouteRouteImport } from './routes/(public)/route'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as publicPreviewRouteImport } from './routes/(public)/preview'
import { Route as publicDevenirChefRouteImport } from './routes/(public)/devenir-chef'
import { Route as publicContactRouteImport } from './routes/(public)/contact'
import { Route as publicCarteCadeauRouteImport } from './routes/(public)/carte-cadeau'
import { Route as publicAvisRouteImport } from './routes/(public)/avis'
import { Route as DashboardClientRouteRouteImport } from './routes/dashboard/client/route'
import { Route as DashboardChefRouteRouteImport } from './routes/dashboard/chef/route'
import { Route as DashboardAdminRouteRouteImport } from './routes/dashboard/admin/route'
import { Route as publicTrouverUnChefRouteRouteImport } from './routes/(public)/trouver-un-chef/route'
import { Route as DashboardClientIndexRouteImport } from './routes/dashboard/client/index'
import { Route as DashboardChefIndexRouteImport } from './routes/dashboard/chef/index'
import { Route as DashboardAdminIndexRouteImport } from './routes/dashboard/admin/index'
import { Route as publicTrouverUnChefIndexRouteImport } from './routes/(public)/trouver-un-chef/index'
import { Route as DashboardClientReservationsRouteImport } from './routes/dashboard/client/reservations'
import { Route as DashboardClientInformationsRouteImport } from './routes/dashboard/client/informations'
import { Route as DashboardClientFavorisRouteImport } from './routes/dashboard/client/favoris'
import { Route as DashboardChefReservationsRouteImport } from './routes/dashboard/chef/reservations'
import { Route as DashboardChefProfilRouteImport } from './routes/dashboard/chef/profil'
import { Route as DashboardChefMenusRouteImport } from './routes/dashboard/chef/menus'
import { Route as DashboardChefInformationsRouteImport } from './routes/dashboard/chef/informations'
import { Route as DashboardChefDisponibilitesRouteImport } from './routes/dashboard/chef/disponibilites'
import { Route as DashboardChefDemandesRouteImport } from './routes/dashboard/chef/demandes'
import { Route as DashboardAdminReservationsRouteImport } from './routes/dashboard/admin/reservations'
import { Route as DashboardAdminChefsRouteImport } from './routes/dashboard/admin/chefs'
import { Route as publicTrouverUnChefMenusRouteImport } from './routes/(public)/trouver-un-chef/menus'
import { Route as publicTrouverUnChefChefsRouteImport } from './routes/(public)/trouver-un-chef/chefs'
import { Route as publicStripeReturnRouteImport } from './routes/(public)/stripe/return'
import { Route as publicStripeRefreshRouteImport } from './routes/(public)/stripe/refresh'
import { Route as publicPaymentSuccessRouteImport } from './routes/(public)/payment/success'
import { Route as publicPaymentCheckoutRouteImport } from './routes/(public)/payment/checkout'
import { Route as publicPaymentCancelRouteImport } from './routes/(public)/payment/cancel'
import { Route as publicPayerTokenRouteImport } from './routes/(public)/payer.$token'
import { Route as publicMenusMenuIdRouteImport } from './routes/(public)/menus.$menuId'
import { Route as publicChefsChefIdRouteImport } from './routes/(public)/chefs.$chefId'
import { Route as publicpoliciesMentionsLegalesRouteImport } from './routes/(public)/(policies)/mentions-legales'
import { Route as publicpoliciesConfidentialiteRouteImport } from './routes/(public)/(policies)/confidentialite'
import { Route as publicpoliciesCgvRouteImport } from './routes/(public)/(policies)/cgv'
import { Route as publicpoliciesCguRouteImport } from './routes/(public)/(policies)/cgu'
import { Route as publicauthVerifyRouteImport } from './routes/(public)/(auth)/verify'
import { Route as publicauthReinitialiserMotDePasseRouteImport } from './routes/(public)/(auth)/reinitialiser-mot-de-passe'
import { Route as publicauthOnboardingRouteImport } from './routes/(public)/(auth)/onboarding'
import { Route as publicauthInscriptionRouteImport } from './routes/(public)/(auth)/inscription'
import { Route as publicauthConnexionRouteImport } from './routes/(public)/(auth)/connexion'

const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const publicRouteRoute = publicRouteRouteImport.update({
  id: '/(public)',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const publicIndexRoute = publicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicPreviewRoute = publicPreviewRouteImport.update({
  id: '/preview',
  path: '/preview',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicDevenirChefRoute = publicDevenirChefRouteImport.update({
  id: '/devenir-chef',
  path: '/devenir-chef',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicContactRoute = publicContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicCarteCadeauRoute = publicCarteCadeauRouteImport.update({
  id: '/carte-cadeau',
  path: '/carte-cadeau',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicAvisRoute = publicAvisRouteImport.update({
  id: '/avis',
  path: '/avis',
  getParentRoute: () => publicRouteRoute,
} as any)
const DashboardClientRouteRoute = DashboardClientRouteRouteImport.update({
  id: '/client',
  path: '/client',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardChefRouteRoute = DashboardChefRouteRouteImport.update({
  id: '/chef',
  path: '/chef',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAdminRouteRoute = DashboardAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const publicTrouverUnChefRouteRoute =
  publicTrouverUnChefRouteRouteImport.update({
    id: '/trouver-un-chef',
    path: '/trouver-un-chef',
    getParentRoute: () => publicRouteRoute,
  } as any)
const DashboardClientIndexRoute = DashboardClientIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardClientRouteRoute,
} as any)
const DashboardChefIndexRoute = DashboardChefIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardChefRouteRoute,
} as any)
const DashboardAdminIndexRoute = DashboardAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)
const publicTrouverUnChefIndexRoute =
  publicTrouverUnChefIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => publicTrouverUnChefRouteRoute,
  } as any)
const DashboardClientReservationsRoute =
  DashboardClientReservationsRouteImport.update({
    id: '/reservations',
    path: '/reservations',
    getParentRoute: () => DashboardClientRouteRoute,
  } as any)
const DashboardClientInformationsRoute =
  DashboardClientInformationsRouteImport.update({
    id: '/informations',
    path: '/informations',
    getParentRoute: () => DashboardClientRouteRoute,
  } as any)
const DashboardClientFavorisRoute = DashboardClientFavorisRouteImport.update({
  id: '/favoris',
  path: '/favoris',
  getParentRoute: () => DashboardClientRouteRoute,
} as any)
const DashboardChefReservationsRoute =
  DashboardChefReservationsRouteImport.update({
    id: '/reservations',
    path: '/reservations',
    getParentRoute: () => DashboardChefRouteRoute,
  } as any)
const DashboardChefProfilRoute = DashboardChefProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => DashboardChefRouteRoute,
} as any)
const DashboardChefMenusRoute = DashboardChefMenusRouteImport.update({
  id: '/menus',
  path: '/menus',
  getParentRoute: () => DashboardChefRouteRoute,
} as any)
const DashboardChefInformationsRoute =
  DashboardChefInformationsRouteImport.update({
    id: '/informations',
    path: '/informations',
    getParentRoute: () => DashboardChefRouteRoute,
  } as any)
const DashboardChefDisponibilitesRoute =
  DashboardChefDisponibilitesRouteImport.update({
    id: '/disponibilites',
    path: '/disponibilites',
    getParentRoute: () => DashboardChefRouteRoute,
  } as any)
const DashboardChefDemandesRoute = DashboardChefDemandesRouteImport.update({
  id: '/demandes',
  path: '/demandes',
  getParentRoute: () => DashboardChefRouteRoute,
} as any)
const DashboardAdminReservationsRoute =
  DashboardAdminReservationsRouteImport.update({
    id: '/reservations',
    path: '/reservations',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminChefsRoute = DashboardAdminChefsRouteImport.update({
  id: '/chefs',
  path: '/chefs',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)
const publicTrouverUnChefMenusRoute =
  publicTrouverUnChefMenusRouteImport.update({
    id: '/menus',
    path: '/menus',
    getParentRoute: () => publicTrouverUnChefRouteRoute,
  } as any)
const publicTrouverUnChefChefsRoute =
  publicTrouverUnChefChefsRouteImport.update({
    id: '/chefs',
    path: '/chefs',
    getParentRoute: () => publicTrouverUnChefRouteRoute,
  } as any)
const publicStripeReturnRoute = publicStripeReturnRouteImport.update({
  id: '/stripe/return',
  path: '/stripe/return',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicStripeRefreshRoute = publicStripeRefreshRouteImport.update({
  id: '/stripe/refresh',
  path: '/stripe/refresh',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicPaymentSuccessRoute = publicPaymentSuccessRouteImport.update({
  id: '/payment/success',
  path: '/payment/success',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicPaymentCheckoutRoute = publicPaymentCheckoutRouteImport.update({
  id: '/payment/checkout',
  path: '/payment/checkout',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicPaymentCancelRoute = publicPaymentCancelRouteImport.update({
  id: '/payment/cancel',
  path: '/payment/cancel',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicPayerTokenRoute = publicPayerTokenRouteImport.update({
  id: '/payer/$token',
  path: '/payer/$token',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicMenusMenuIdRoute = publicMenusMenuIdRouteImport.update({
  id: '/menus/$menuId',
  path: '/menus/$menuId',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicChefsChefIdRoute = publicChefsChefIdRouteImport.update({
  id: '/chefs/$chefId',
  path: '/chefs/$chefId',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicpoliciesMentionsLegalesRoute =
  publicpoliciesMentionsLegalesRouteImport.update({
    id: '/(policies)/mentions-legales',
    path: '/mentions-legales',
    getParentRoute: () => publicRouteRoute,
  } as any)
const publicpoliciesConfidentialiteRoute =
  publicpoliciesConfidentialiteRouteImport.update({
    id: '/(policies)/confidentialite',
    path: '/confidentialite',
    getParentRoute: () => publicRouteRoute,
  } as any)
const publicpoliciesCgvRoute = publicpoliciesCgvRouteImport.update({
  id: '/(policies)/cgv',
  path: '/cgv',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicpoliciesCguRoute = publicpoliciesCguRouteImport.update({
  id: '/(policies)/cgu',
  path: '/cgu',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicauthVerifyRoute = publicauthVerifyRouteImport.update({
  id: '/(auth)/verify',
  path: '/verify',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicauthReinitialiserMotDePasseRoute =
  publicauthReinitialiserMotDePasseRouteImport.update({
    id: '/(auth)/reinitialiser-mot-de-passe',
    path: '/reinitialiser-mot-de-passe',
    getParentRoute: () => publicRouteRoute,
  } as any)
const publicauthOnboardingRoute = publicauthOnboardingRouteImport.update({
  id: '/(auth)/onboarding',
  path: '/onboarding',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicauthInscriptionRoute = publicauthInscriptionRouteImport.update({
  id: '/(auth)/inscription',
  path: '/inscription',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicauthConnexionRoute = publicauthConnexionRouteImport.update({
  id: '/(auth)/connexion',
  path: '/connexion',
  getParentRoute: () => publicRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof publicIndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/trouver-un-chef': typeof publicTrouverUnChefRouteRouteWithChildren
  '/dashboard/admin': typeof DashboardAdminRouteRouteWithChildren
  '/dashboard/chef': typeof DashboardChefRouteRouteWithChildren
  '/dashboard/client': typeof DashboardClientRouteRouteWithChildren
  '/avis': typeof publicAvisRoute
  '/carte-cadeau': typeof publicCarteCadeauRoute
  '/contact': typeof publicContactRoute
  '/devenir-chef': typeof publicDevenirChefRoute
  '/preview': typeof publicPreviewRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/connexion': typeof publicauthConnexionRoute
  '/inscription': typeof publicauthInscriptionRoute
  '/onboarding': typeof publicauthOnboardingRoute
  '/reinitialiser-mot-de-passe': typeof publicauthReinitialiserMotDePasseRoute
  '/verify': typeof publicauthVerifyRoute
  '/cgu': typeof publicpoliciesCguRoute
  '/cgv': typeof publicpoliciesCgvRoute
  '/confidentialite': typeof publicpoliciesConfidentialiteRoute
  '/mentions-legales': typeof publicpoliciesMentionsLegalesRoute
  '/chefs/$chefId': typeof publicChefsChefIdRoute
  '/menus/$menuId': typeof publicMenusMenuIdRoute
  '/payer/$token': typeof publicPayerTokenRoute
  '/payment/cancel': typeof publicPaymentCancelRoute
  '/payment/checkout': typeof publicPaymentCheckoutRoute
  '/payment/success': typeof publicPaymentSuccessRoute
  '/stripe/refresh': typeof publicStripeRefreshRoute
  '/stripe/return': typeof publicStripeReturnRoute
  '/trouver-un-chef/chefs': typeof publicTrouverUnChefChefsRoute
  '/trouver-un-chef/menus': typeof publicTrouverUnChefMenusRoute
  '/dashboard/admin/chefs': typeof DashboardAdminChefsRoute
  '/dashboard/admin/reservations': typeof DashboardAdminReservationsRoute
  '/dashboard/chef/demandes': typeof DashboardChefDemandesRoute
  '/dashboard/chef/disponibilites': typeof DashboardChefDisponibilitesRoute
  '/dashboard/chef/informations': typeof DashboardChefInformationsRoute
  '/dashboard/chef/menus': typeof DashboardChefMenusRoute
  '/dashboard/chef/profil': typeof DashboardChefProfilRoute
  '/dashboard/chef/reservations': typeof DashboardChefReservationsRoute
  '/dashboard/client/favoris': typeof DashboardClientFavorisRoute
  '/dashboard/client/informations': typeof DashboardClientInformationsRoute
  '/dashboard/client/reservations': typeof DashboardClientReservationsRoute
  '/trouver-un-chef/': typeof publicTrouverUnChefIndexRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/chef/': typeof DashboardChefIndexRoute
  '/dashboard/client/': typeof DashboardClientIndexRoute
}
export interface FileRoutesByTo {
  '/avis': typeof publicAvisRoute
  '/carte-cadeau': typeof publicCarteCadeauRoute
  '/contact': typeof publicContactRoute
  '/devenir-chef': typeof publicDevenirChefRoute
  '/preview': typeof publicPreviewRoute
  '/': typeof publicIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/connexion': typeof publicauthConnexionRoute
  '/inscription': typeof publicauthInscriptionRoute
  '/onboarding': typeof publicauthOnboardingRoute
  '/reinitialiser-mot-de-passe': typeof publicauthReinitialiserMotDePasseRoute
  '/verify': typeof publicauthVerifyRoute
  '/cgu': typeof publicpoliciesCguRoute
  '/cgv': typeof publicpoliciesCgvRoute
  '/confidentialite': typeof publicpoliciesConfidentialiteRoute
  '/mentions-legales': typeof publicpoliciesMentionsLegalesRoute
  '/chefs/$chefId': typeof publicChefsChefIdRoute
  '/menus/$menuId': typeof publicMenusMenuIdRoute
  '/payer/$token': typeof publicPayerTokenRoute
  '/payment/cancel': typeof publicPaymentCancelRoute
  '/payment/checkout': typeof publicPaymentCheckoutRoute
  '/payment/success': typeof publicPaymentSuccessRoute
  '/stripe/refresh': typeof publicStripeRefreshRoute
  '/stripe/return': typeof publicStripeReturnRoute
  '/trouver-un-chef/chefs': typeof publicTrouverUnChefChefsRoute
  '/trouver-un-chef/menus': typeof publicTrouverUnChefMenusRoute
  '/dashboard/admin/chefs': typeof DashboardAdminChefsRoute
  '/dashboard/admin/reservations': typeof DashboardAdminReservationsRoute
  '/dashboard/chef/demandes': typeof DashboardChefDemandesRoute
  '/dashboard/chef/disponibilites': typeof DashboardChefDisponibilitesRoute
  '/dashboard/chef/informations': typeof DashboardChefInformationsRoute
  '/dashboard/chef/menus': typeof DashboardChefMenusRoute
  '/dashboard/chef/profil': typeof DashboardChefProfilRoute
  '/dashboard/chef/reservations': typeof DashboardChefReservationsRoute
  '/dashboard/client/favoris': typeof DashboardClientFavorisRoute
  '/dashboard/client/informations': typeof DashboardClientInformationsRoute
  '/dashboard/client/reservations': typeof DashboardClientReservationsRoute
  '/trouver-un-chef': typeof publicTrouverUnChefIndexRoute
  '/dashboard/admin': typeof DashboardAdminIndexRoute
  '/dashboard/chef': typeof DashboardChefIndexRoute
  '/dashboard/client': typeof DashboardClientIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(public)': typeof publicRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/(public)/trouver-un-chef': typeof publicTrouverUnChefRouteRouteWithChildren
  '/dashboard/admin': typeof DashboardAdminRouteRouteWithChildren
  '/dashboard/chef': typeof DashboardChefRouteRouteWithChildren
  '/dashboard/client': typeof DashboardClientRouteRouteWithChildren
  '/(public)/avis': typeof publicAvisRoute
  '/(public)/carte-cadeau': typeof publicCarteCadeauRoute
  '/(public)/contact': typeof publicContactRoute
  '/(public)/devenir-chef': typeof publicDevenirChefRoute
  '/(public)/preview': typeof publicPreviewRoute
  '/(public)/': typeof publicIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/(public)/(auth)/connexion': typeof publicauthConnexionRoute
  '/(public)/(auth)/inscription': typeof publicauthInscriptionRoute
  '/(public)/(auth)/onboarding': typeof publicauthOnboardingRoute
  '/(public)/(auth)/reinitialiser-mot-de-passe': typeof publicauthReinitialiserMotDePasseRoute
  '/(public)/(auth)/verify': typeof publicauthVerifyRoute
  '/(public)/(policies)/cgu': typeof publicpoliciesCguRoute
  '/(public)/(policies)/cgv': typeof publicpoliciesCgvRoute
  '/(public)/(policies)/confidentialite': typeof publicpoliciesConfidentialiteRoute
  '/(public)/(policies)/mentions-legales': typeof publicpoliciesMentionsLegalesRoute
  '/(public)/chefs/$chefId': typeof publicChefsChefIdRoute
  '/(public)/menus/$menuId': typeof publicMenusMenuIdRoute
  '/(public)/payer/$token': typeof publicPayerTokenRoute
  '/(public)/payment/cancel': typeof publicPaymentCancelRoute
  '/(public)/payment/checkout': typeof publicPaymentCheckoutRoute
  '/(public)/payment/success': typeof publicPaymentSuccessRoute
  '/(public)/stripe/refresh': typeof publicStripeRefreshRoute
  '/(public)/stripe/return': typeof publicStripeReturnRoute
  '/(public)/trouver-un-chef/chefs': typeof publicTrouverUnChefChefsRoute
  '/(public)/trouver-un-chef/menus': typeof publicTrouverUnChefMenusRoute
  '/dashboard/admin/chefs': typeof DashboardAdminChefsRoute
  '/dashboard/admin/reservations': typeof DashboardAdminReservationsRoute
  '/dashboard/chef/demandes': typeof DashboardChefDemandesRoute
  '/dashboard/chef/disponibilites': typeof DashboardChefDisponibilitesRoute
  '/dashboard/chef/informations': typeof DashboardChefInformationsRoute
  '/dashboard/chef/menus': typeof DashboardChefMenusRoute
  '/dashboard/chef/profil': typeof DashboardChefProfilRoute
  '/dashboard/chef/reservations': typeof DashboardChefReservationsRoute
  '/dashboard/client/favoris': typeof DashboardClientFavorisRoute
  '/dashboard/client/informations': typeof DashboardClientInformationsRoute
  '/dashboard/client/reservations': typeof DashboardClientReservationsRoute
  '/(public)/trouver-un-chef/': typeof publicTrouverUnChefIndexRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/chef/': typeof DashboardChefIndexRoute
  '/dashboard/client/': typeof DashboardClientIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/trouver-un-chef'
    | '/dashboard/admin'
    | '/dashboard/chef'
    | '/dashboard/client'
    | '/avis'
    | '/carte-cadeau'
    | '/contact'
    | '/devenir-chef'
    | '/preview'
    | '/dashboard/'
    | '/connexion'
    | '/inscription'
    | '/onboarding'
    | '/reinitialiser-mot-de-passe'
    | '/verify'
    | '/cgu'
    | '/cgv'
    | '/confidentialite'
    | '/mentions-legales'
    | '/chefs/$chefId'
    | '/menus/$menuId'
    | '/payer/$token'
    | '/payment/cancel'
    | '/payment/checkout'
    | '/payment/success'
    | '/stripe/refresh'
    | '/stripe/return'
    | '/trouver-un-chef/chefs'
    | '/trouver-un-chef/menus'
    | '/dashboard/admin/chefs'
    | '/dashboard/admin/reservations'
    | '/dashboard/chef/demandes'
    | '/dashboard/chef/disponibilites'
    | '/dashboard/chef/informations'
    | '/dashboard/chef/menus'
    | '/dashboard/chef/profil'
    | '/dashboard/chef/reservations'
    | '/dashboard/client/favoris'
    | '/dashboard/client/informations'
    | '/dashboard/client/reservations'
    | '/trouver-un-chef/'
    | '/dashboard/admin/'
    | '/dashboard/chef/'
    | '/dashboard/client/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/avis'
    | '/carte-cadeau'
    | '/contact'
    | '/devenir-chef'
    | '/preview'
    | '/'
    | '/dashboard'
    | '/connexion'
    | '/inscription'
    | '/onboarding'
    | '/reinitialiser-mot-de-passe'
    | '/verify'
    | '/cgu'
    | '/cgv'
    | '/confidentialite'
    | '/mentions-legales'
    | '/chefs/$chefId'
    | '/menus/$menuId'
    | '/payer/$token'
    | '/payment/cancel'
    | '/payment/checkout'
    | '/payment/success'
    | '/stripe/refresh'
    | '/stripe/return'
    | '/trouver-un-chef/chefs'
    | '/trouver-un-chef/menus'
    | '/dashboard/admin/chefs'
    | '/dashboard/admin/reservations'
    | '/dashboard/chef/demandes'
    | '/dashboard/chef/disponibilites'
    | '/dashboard/chef/informations'
    | '/dashboard/chef/menus'
    | '/dashboard/chef/profil'
    | '/dashboard/chef/reservations'
    | '/dashboard/client/favoris'
    | '/dashboard/client/informations'
    | '/dashboard/client/reservations'
    | '/trouver-un-chef'
    | '/dashboard/admin'
    | '/dashboard/chef'
    | '/dashboard/client'
  id:
    | '__root__'
    | '/(public)'
    | '/dashboard'
    | '/(public)/trouver-un-chef'
    | '/dashboard/admin'
    | '/dashboard/chef'
    | '/dashboard/client'
    | '/(public)/avis'
    | '/(public)/carte-cadeau'
    | '/(public)/contact'
    | '/(public)/devenir-chef'
    | '/(public)/preview'
    | '/(public)/'
    | '/dashboard/'
    | '/(public)/(auth)/connexion'
    | '/(public)/(auth)/inscription'
    | '/(public)/(auth)/onboarding'
    | '/(public)/(auth)/reinitialiser-mot-de-passe'
    | '/(public)/(auth)/verify'
    | '/(public)/(policies)/cgu'
    | '/(public)/(policies)/cgv'
    | '/(public)/(policies)/confidentialite'
    | '/(public)/(policies)/mentions-legales'
    | '/(public)/chefs/$chefId'
    | '/(public)/menus/$menuId'
    | '/(public)/payer/$token'
    | '/(public)/payment/cancel'
    | '/(public)/payment/checkout'
    | '/(public)/payment/success'
    | '/(public)/stripe/refresh'
    | '/(public)/stripe/return'
    | '/(public)/trouver-un-chef/chefs'
    | '/(public)/trouver-un-chef/menus'
    | '/dashboard/admin/chefs'
    | '/dashboard/admin/reservations'
    | '/dashboard/chef/demandes'
    | '/dashboard/chef/disponibilites'
    | '/dashboard/chef/informations'
    | '/dashboard/chef/menus'
    | '/dashboard/chef/profil'
    | '/dashboard/chef/reservations'
    | '/dashboard/client/favoris'
    | '/dashboard/client/informations'
    | '/dashboard/client/reservations'
    | '/(public)/trouver-un-chef/'
    | '/dashboard/admin/'
    | '/dashboard/chef/'
    | '/dashboard/client/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  publicRouteRoute: typeof publicRouteRouteWithChildren
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)': {
      id: '/(public)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/(public)/': {
      id: '/(public)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicIndexRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/preview': {
      id: '/(public)/preview'
      path: '/preview'
      fullPath: '/preview'
      preLoaderRoute: typeof publicPreviewRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/devenir-chef': {
      id: '/(public)/devenir-chef'
      path: '/devenir-chef'
      fullPath: '/devenir-chef'
      preLoaderRoute: typeof publicDevenirChefRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/contact': {
      id: '/(public)/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof publicContactRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/carte-cadeau': {
      id: '/(public)/carte-cadeau'
      path: '/carte-cadeau'
      fullPath: '/carte-cadeau'
      preLoaderRoute: typeof publicCarteCadeauRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/avis': {
      id: '/(public)/avis'
      path: '/avis'
      fullPath: '/avis'
      preLoaderRoute: typeof publicAvisRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/dashboard/client': {
      id: '/dashboard/client'
      path: '/client'
      fullPath: '/dashboard/client'
      preLoaderRoute: typeof DashboardClientRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/chef': {
      id: '/dashboard/chef'
      path: '/chef'
      fullPath: '/dashboard/chef'
      preLoaderRoute: typeof DashboardChefRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/admin': {
      id: '/dashboard/admin'
      path: '/admin'
      fullPath: '/dashboard/admin'
      preLoaderRoute: typeof DashboardAdminRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/(public)/trouver-un-chef': {
      id: '/(public)/trouver-un-chef'
      path: '/trouver-un-chef'
      fullPath: '/trouver-un-chef'
      preLoaderRoute: typeof publicTrouverUnChefRouteRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/dashboard/client/': {
      id: '/dashboard/client/'
      path: '/'
      fullPath: '/dashboard/client/'
      preLoaderRoute: typeof DashboardClientIndexRouteImport
      parentRoute: typeof DashboardClientRouteRoute
    }
    '/dashboard/chef/': {
      id: '/dashboard/chef/'
      path: '/'
      fullPath: '/dashboard/chef/'
      preLoaderRoute: typeof DashboardChefIndexRouteImport
      parentRoute: typeof DashboardChefRouteRoute
    }
    '/dashboard/admin/': {
      id: '/dashboard/admin/'
      path: '/'
      fullPath: '/dashboard/admin/'
      preLoaderRoute: typeof DashboardAdminIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/(public)/trouver-un-chef/': {
      id: '/(public)/trouver-un-chef/'
      path: '/'
      fullPath: '/trouver-un-chef/'
      preLoaderRoute: typeof publicTrouverUnChefIndexRouteImport
      parentRoute: typeof publicTrouverUnChefRouteRoute
    }
    '/dashboard/client/reservations': {
      id: '/dashboard/client/reservations'
      path: '/reservations'
      fullPath: '/dashboard/client/reservations'
      preLoaderRoute: typeof DashboardClientReservationsRouteImport
      parentRoute: typeof DashboardClientRouteRoute
    }
    '/dashboard/client/informations': {
      id: '/dashboard/client/informations'
      path: '/informations'
      fullPath: '/dashboard/client/informations'
      preLoaderRoute: typeof DashboardClientInformationsRouteImport
      parentRoute: typeof DashboardClientRouteRoute
    }
    '/dashboard/client/favoris': {
      id: '/dashboard/client/favoris'
      path: '/favoris'
      fullPath: '/dashboard/client/favoris'
      preLoaderRoute: typeof DashboardClientFavorisRouteImport
      parentRoute: typeof DashboardClientRouteRoute
    }
    '/dashboard/chef/reservations': {
      id: '/dashboard/chef/reservations'
      path: '/reservations'
      fullPath: '/dashboard/chef/reservations'
      preLoaderRoute: typeof DashboardChefReservationsRouteImport
      parentRoute: typeof DashboardChefRouteRoute
    }
    '/dashboard/chef/profil': {
      id: '/dashboard/chef/profil'
      path: '/profil'
      fullPath: '/dashboard/chef/profil'
      preLoaderRoute: typeof DashboardChefProfilRouteImport
      parentRoute: typeof DashboardChefRouteRoute
    }
    '/dashboard/chef/menus': {
      id: '/dashboard/chef/menus'
      path: '/menus'
      fullPath: '/dashboard/chef/menus'
      preLoaderRoute: typeof DashboardChefMenusRouteImport
      parentRoute: typeof DashboardChefRouteRoute
    }
    '/dashboard/chef/informations': {
      id: '/dashboard/chef/informations'
      path: '/informations'
      fullPath: '/dashboard/chef/informations'
      preLoaderRoute: typeof DashboardChefInformationsRouteImport
      parentRoute: typeof DashboardChefRouteRoute
    }
    '/dashboard/chef/disponibilites': {
      id: '/dashboard/chef/disponibilites'
      path: '/disponibilites'
      fullPath: '/dashboard/chef/disponibilites'
      preLoaderRoute: typeof DashboardChefDisponibilitesRouteImport
      parentRoute: typeof DashboardChefRouteRoute
    }
    '/dashboard/chef/demandes': {
      id: '/dashboard/chef/demandes'
      path: '/demandes'
      fullPath: '/dashboard/chef/demandes'
      preLoaderRoute: typeof DashboardChefDemandesRouteImport
      parentRoute: typeof DashboardChefRouteRoute
    }
    '/dashboard/admin/reservations': {
      id: '/dashboard/admin/reservations'
      path: '/reservations'
      fullPath: '/dashboard/admin/reservations'
      preLoaderRoute: typeof DashboardAdminReservationsRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/chefs': {
      id: '/dashboard/admin/chefs'
      path: '/chefs'
      fullPath: '/dashboard/admin/chefs'
      preLoaderRoute: typeof DashboardAdminChefsRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/(public)/trouver-un-chef/menus': {
      id: '/(public)/trouver-un-chef/menus'
      path: '/menus'
      fullPath: '/trouver-un-chef/menus'
      preLoaderRoute: typeof publicTrouverUnChefMenusRouteImport
      parentRoute: typeof publicTrouverUnChefRouteRoute
    }
    '/(public)/trouver-un-chef/chefs': {
      id: '/(public)/trouver-un-chef/chefs'
      path: '/chefs'
      fullPath: '/trouver-un-chef/chefs'
      preLoaderRoute: typeof publicTrouverUnChefChefsRouteImport
      parentRoute: typeof publicTrouverUnChefRouteRoute
    }
    '/(public)/stripe/return': {
      id: '/(public)/stripe/return'
      path: '/stripe/return'
      fullPath: '/stripe/return'
      preLoaderRoute: typeof publicStripeReturnRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/stripe/refresh': {
      id: '/(public)/stripe/refresh'
      path: '/stripe/refresh'
      fullPath: '/stripe/refresh'
      preLoaderRoute: typeof publicStripeRefreshRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/payment/success': {
      id: '/(public)/payment/success'
      path: '/payment/success'
      fullPath: '/payment/success'
      preLoaderRoute: typeof publicPaymentSuccessRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/payment/checkout': {
      id: '/(public)/payment/checkout'
      path: '/payment/checkout'
      fullPath: '/payment/checkout'
      preLoaderRoute: typeof publicPaymentCheckoutRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/payment/cancel': {
      id: '/(public)/payment/cancel'
      path: '/payment/cancel'
      fullPath: '/payment/cancel'
      preLoaderRoute: typeof publicPaymentCancelRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/payer/$token': {
      id: '/(public)/payer/$token'
      path: '/payer/$token'
      fullPath: '/payer/$token'
      preLoaderRoute: typeof publicPayerTokenRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/menus/$menuId': {
      id: '/(public)/menus/$menuId'
      path: '/menus/$menuId'
      fullPath: '/menus/$menuId'
      preLoaderRoute: typeof publicMenusMenuIdRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/chefs/$chefId': {
      id: '/(public)/chefs/$chefId'
      path: '/chefs/$chefId'
      fullPath: '/chefs/$chefId'
      preLoaderRoute: typeof publicChefsChefIdRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/(policies)/mentions-legales': {
      id: '/(public)/(policies)/mentions-legales'
      path: '/mentions-legales'
      fullPath: '/mentions-legales'
      preLoaderRoute: typeof publicpoliciesMentionsLegalesRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/(policies)/confidentialite': {
      id: '/(public)/(policies)/confidentialite'
      path: '/confidentialite'
      fullPath: '/confidentialite'
      preLoaderRoute: typeof publicpoliciesConfidentialiteRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/(policies)/cgv': {
      id: '/(public)/(policies)/cgv'
      path: '/cgv'
      fullPath: '/cgv'
      preLoaderRoute: typeof publicpoliciesCgvRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/(policies)/cgu': {
      id: '/(public)/(policies)/cgu'
      path: '/cgu'
      fullPath: '/cgu'
      preLoaderRoute: typeof publicpoliciesCguRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/(auth)/verify': {
      id: '/(public)/(auth)/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof publicauthVerifyRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/(auth)/reinitialiser-mot-de-passe': {
      id: '/(public)/(auth)/reinitialiser-mot-de-passe'
      path: '/reinitialiser-mot-de-passe'
      fullPath: '/reinitialiser-mot-de-passe'
      preLoaderRoute: typeof publicauthReinitialiserMotDePasseRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/(auth)/onboarding': {
      id: '/(public)/(auth)/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof publicauthOnboardingRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/(auth)/inscription': {
      id: '/(public)/(auth)/inscription'
      path: '/inscription'
      fullPath: '/inscription'
      preLoaderRoute: typeof publicauthInscriptionRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/(auth)/connexion': {
      id: '/(public)/(auth)/connexion'
      path: '/connexion'
      fullPath: '/connexion'
      preLoaderRoute: typeof publicauthConnexionRouteImport
      parentRoute: typeof publicRouteRoute
    }
  }
}

interface publicTrouverUnChefRouteRouteChildren {
  publicTrouverUnChefChefsRoute: typeof publicTrouverUnChefChefsRoute
  publicTrouverUnChefMenusRoute: typeof publicTrouverUnChefMenusRoute
  publicTrouverUnChefIndexRoute: typeof publicTrouverUnChefIndexRoute
}

const publicTrouverUnChefRouteRouteChildren: publicTrouverUnChefRouteRouteChildren =
  {
    publicTrouverUnChefChefsRoute: publicTrouverUnChefChefsRoute,
    publicTrouverUnChefMenusRoute: publicTrouverUnChefMenusRoute,
    publicTrouverUnChefIndexRoute: publicTrouverUnChefIndexRoute,
  }

const publicTrouverUnChefRouteRouteWithChildren =
  publicTrouverUnChefRouteRoute._addFileChildren(
    publicTrouverUnChefRouteRouteChildren,
  )

interface publicRouteRouteChildren {
  publicTrouverUnChefRouteRoute: typeof publicTrouverUnChefRouteRouteWithChildren
  publicAvisRoute: typeof publicAvisRoute
  publicCarteCadeauRoute: typeof publicCarteCadeauRoute
  publicContactRoute: typeof publicContactRoute
  publicDevenirChefRoute: typeof publicDevenirChefRoute
  publicPreviewRoute: typeof publicPreviewRoute
  publicIndexRoute: typeof publicIndexRoute
  publicauthConnexionRoute: typeof publicauthConnexionRoute
  publicauthInscriptionRoute: typeof publicauthInscriptionRoute
  publicauthOnboardingRoute: typeof publicauthOnboardingRoute
  publicauthReinitialiserMotDePasseRoute: typeof publicauthReinitialiserMotDePasseRoute
  publicauthVerifyRoute: typeof publicauthVerifyRoute
  publicpoliciesCguRoute: typeof publicpoliciesCguRoute
  publicpoliciesCgvRoute: typeof publicpoliciesCgvRoute
  publicpoliciesConfidentialiteRoute: typeof publicpoliciesConfidentialiteRoute
  publicpoliciesMentionsLegalesRoute: typeof publicpoliciesMentionsLegalesRoute
  publicChefsChefIdRoute: typeof publicChefsChefIdRoute
  publicMenusMenuIdRoute: typeof publicMenusMenuIdRoute
  publicPayerTokenRoute: typeof publicPayerTokenRoute
  publicPaymentCancelRoute: typeof publicPaymentCancelRoute
  publicPaymentCheckoutRoute: typeof publicPaymentCheckoutRoute
  publicPaymentSuccessRoute: typeof publicPaymentSuccessRoute
  publicStripeRefreshRoute: typeof publicStripeRefreshRoute
  publicStripeReturnRoute: typeof publicStripeReturnRoute
}

const publicRouteRouteChildren: publicRouteRouteChildren = {
  publicTrouverUnChefRouteRoute: publicTrouverUnChefRouteRouteWithChildren,
  publicAvisRoute: publicAvisRoute,
  publicCarteCadeauRoute: publicCarteCadeauRoute,
  publicContactRoute: publicContactRoute,
  publicDevenirChefRoute: publicDevenirChefRoute,
  publicPreviewRoute: publicPreviewRoute,
  publicIndexRoute: publicIndexRoute,
  publicauthConnexionRoute: publicauthConnexionRoute,
  publicauthInscriptionRoute: publicauthInscriptionRoute,
  publicauthOnboardingRoute: publicauthOnboardingRoute,
  publicauthReinitialiserMotDePasseRoute:
    publicauthReinitialiserMotDePasseRoute,
  publicauthVerifyRoute: publicauthVerifyRoute,
  publicpoliciesCguRoute: publicpoliciesCguRoute,
  publicpoliciesCgvRoute: publicpoliciesCgvRoute,
  publicpoliciesConfidentialiteRoute: publicpoliciesConfidentialiteRoute,
  publicpoliciesMentionsLegalesRoute: publicpoliciesMentionsLegalesRoute,
  publicChefsChefIdRoute: publicChefsChefIdRoute,
  publicMenusMenuIdRoute: publicMenusMenuIdRoute,
  publicPayerTokenRoute: publicPayerTokenRoute,
  publicPaymentCancelRoute: publicPaymentCancelRoute,
  publicPaymentCheckoutRoute: publicPaymentCheckoutRoute,
  publicPaymentSuccessRoute: publicPaymentSuccessRoute,
  publicStripeRefreshRoute: publicStripeRefreshRoute,
  publicStripeReturnRoute: publicStripeReturnRoute,
}

const publicRouteRouteWithChildren = publicRouteRoute._addFileChildren(
  publicRouteRouteChildren,
)

interface DashboardAdminRouteRouteChildren {
  DashboardAdminChefsRoute: typeof DashboardAdminChefsRoute
  DashboardAdminReservationsRoute: typeof DashboardAdminReservationsRoute
  DashboardAdminIndexRoute: typeof DashboardAdminIndexRoute
}

const DashboardAdminRouteRouteChildren: DashboardAdminRouteRouteChildren = {
  DashboardAdminChefsRoute: DashboardAdminChefsRoute,
  DashboardAdminReservationsRoute: DashboardAdminReservationsRoute,
  DashboardAdminIndexRoute: DashboardAdminIndexRoute,
}

const DashboardAdminRouteRouteWithChildren =
  DashboardAdminRouteRoute._addFileChildren(DashboardAdminRouteRouteChildren)

interface DashboardChefRouteRouteChildren {
  DashboardChefDemandesRoute: typeof DashboardChefDemandesRoute
  DashboardChefDisponibilitesRoute: typeof DashboardChefDisponibilitesRoute
  DashboardChefInformationsRoute: typeof DashboardChefInformationsRoute
  DashboardChefMenusRoute: typeof DashboardChefMenusRoute
  DashboardChefProfilRoute: typeof DashboardChefProfilRoute
  DashboardChefReservationsRoute: typeof DashboardChefReservationsRoute
  DashboardChefIndexRoute: typeof DashboardChefIndexRoute
}

const DashboardChefRouteRouteChildren: DashboardChefRouteRouteChildren = {
  DashboardChefDemandesRoute: DashboardChefDemandesRoute,
  DashboardChefDisponibilitesRoute: DashboardChefDisponibilitesRoute,
  DashboardChefInformationsRoute: DashboardChefInformationsRoute,
  DashboardChefMenusRoute: DashboardChefMenusRoute,
  DashboardChefProfilRoute: DashboardChefProfilRoute,
  DashboardChefReservationsRoute: DashboardChefReservationsRoute,
  DashboardChefIndexRoute: DashboardChefIndexRoute,
}

const DashboardChefRouteRouteWithChildren =
  DashboardChefRouteRoute._addFileChildren(DashboardChefRouteRouteChildren)

interface DashboardClientRouteRouteChildren {
  DashboardClientFavorisRoute: typeof DashboardClientFavorisRoute
  DashboardClientInformationsRoute: typeof DashboardClientInformationsRoute
  DashboardClientReservationsRoute: typeof DashboardClientReservationsRoute
  DashboardClientIndexRoute: typeof DashboardClientIndexRoute
}

const DashboardClientRouteRouteChildren: DashboardClientRouteRouteChildren = {
  DashboardClientFavorisRoute: DashboardClientFavorisRoute,
  DashboardClientInformationsRoute: DashboardClientInformationsRoute,
  DashboardClientReservationsRoute: DashboardClientReservationsRoute,
  DashboardClientIndexRoute: DashboardClientIndexRoute,
}

const DashboardClientRouteRouteWithChildren =
  DashboardClientRouteRoute._addFileChildren(DashboardClientRouteRouteChildren)

interface DashboardRouteRouteChildren {
  DashboardAdminRouteRoute: typeof DashboardAdminRouteRouteWithChildren
  DashboardChefRouteRoute: typeof DashboardChefRouteRouteWithChildren
  DashboardClientRouteRoute: typeof DashboardClientRouteRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardAdminRouteRoute: DashboardAdminRouteRouteWithChildren,
  DashboardChefRouteRoute: DashboardChefRouteRouteWithChildren,
  DashboardClientRouteRoute: DashboardClientRouteRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  publicRouteRoute: publicRouteRouteWithChildren,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
